import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@icons/classic/regular';
import { Body } from '../typography';
import { FlexContainer } from './FlexContainer';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { ComponentProps, ReactNode } from 'react';
export interface TaskLayoutProps {
  icon: IconDefinition;
  description?: string;
  descriptionSize?: ComponentProps<typeof Body>['size'];
  neededFor: string;
  effectiveDate?: string;
  actions?: ReactNode;
  children?: ReactNode;
}
function formatEffectiveDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-');
  return `${month}/${day}/${year.slice(2)}`;
}

/** Shared Dashboard/Admin presentation for a customer onboarding task. */
export default function TaskLayout(t0) {
  const $ = _c(22);
  const {
    icon,
    description,
    descriptionSize: t1,
    neededFor,
    effectiveDate,
    actions,
    children
  } = t0;
  const descriptionSize = t1 === undefined ? "md" : t1;
  let t2;
  if ($[0] !== icon) {
    t2 = <FlexContainer className="bg-background-warning-light border-border-tag-warning size-9 shrink-0 rounded-sm border" items="center" justify="center"><FontAwesomeIcon className="text-content-warning-dark" icon={icon} /></FlexContainer>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== description || $[3] !== descriptionSize) {
    t3 = description && <Body size={descriptionSize} weight="medium">{description}</Body>;
    $[2] = description;
    $[3] = descriptionSize;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== effectiveDate || $[6] !== neededFor) {
    t4 = effectiveDate ? <FlexContainer className="gap-1" items="center"><Body className="text-content-secondary" size="sm">Needed before {formatEffectiveDate(effectiveDate)} to maintain {neededFor}</Body><FontAwesomeIcon className="text-content-negative text-xs" icon={faTriangleExclamation} /></FlexContainer> : <Body className="text-content-secondary" size="sm">Needed for {neededFor}</Body>;
    $[5] = effectiveDate;
    $[6] = neededFor;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <FlexContainer className="flex-1" direction="column">{t3}{t4}</FlexContainer>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <FlexContainer className="gap-3" shrink={true}>{t2}{t5}</FlexContainer>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== actions) {
    t7 = actions && <FlexContainer className="gap-3 shrink-0">{actions}</FlexContainer>;
    $[14] = actions;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <FlexContainer className="w-full gap-6" justify="between">{t6}{t7}</FlexContainer>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== children || $[20] !== t8) {
    t9 = <>{t8}{children}</>;
    $[19] = children;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}